import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getRegisterResultReviewHistories } from 'apis/registerResult.api';

const useGetRegisterResultReviewHistories = (id, conds = {}) => {
  const { data: _data, ...rest } = useQuery(
    ['registerResultReviewHistories', id, conds],
    () => getRegisterResultReviewHistories(id),
    {
      ...conds,
    }
  );

  const data = useMemo(() => _data?.data ?? [], [_data]);

  return { data, ...rest };
};

export default useGetRegisterResultReviewHistories;
